import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import CryptoJS from 'crypto-js'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { __WebKeyUSER, commonUriAll } from '../CommonUrlList/CommonUrlList'
import { DecryptOrderFunction, EncryptOrderFun } from '../features/CryptoJsService'
import { closeLoginModal } from '../features/ModalSlice'

export const LoginModal = () => {
    const getCookieData = (cname) => {
        var name = cname + "="
        var decodeCookie = decodeURIComponent(document.cookie)
        var ca = decodeCookie.split(";")
        for (let i = 0; i < ca.length; i++) {
            const element = ca[i];
            while (element.charAt(0) === ".") {
                element = element.substring(1)
            }
            if (element.indexOf(name) === 0) {
                return element.substring(name.length, element.length)
            }
        }
        return ""
    }

    const dispatch = useDispatch()
    const [ip, setIP] = useState("");
    const navigate = useNavigate()
    const [loginData, setLoginData] = useState({
        username: localStorage.getItem('username'),
        password: localStorage.getItem("pswd"),
        checkBox: localStorage.getItem('remember')
    })
    const [cLoag, setCLoag] = useState(false)

    // const getData = async () => {
    //     const res = await fetch("https://api.ipify.org/?format=json");
    //     const data = await res.json()
    //     setIP(data.ip);
    //     localStorage.setItem("ip", data.ip)
    // };

    const onChange = (e) => {
        setLoginData({ ...loginData, [e.target.name]: e.target.value })
    }

    const onCheck = (e) => {
        setLoginData({ ...loginData, [e.target.name]: e.target.checked })
    }

    const toggleEye = () => {
        var inId = document.getElementById("password-field")
        var tId = document.getElementById("eye-toogle")
        if (inId.type === "text") {
            tId.classList.remove("fa-eye-slash")
            tId.classList.add("fa-eye")
            inId.type = "password"
        } else {
            tId.classList.remove("fa-eye")
            tId.classList.add("fa-eye-slash")
            inId.type = "text"
        }
    }

    const loginUser2 = async (e) => {
        e.preventDefault()
        loginApi(loginData.username, loginData.password).then((data) => {
            if (data.status !== "success") {
                toast.error(data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            } else {
                if (data.data.stUserName !== 'MAGICHM' && data.data.stUserName !== 'MAGICHM2' && data.data.stUserName !== 'MAGICHM3' && data.data.stUserName !== 'MAGICHM4' && data.data.stUserName !== 'MAGICHM8' && data.data.stUserName !== 'MAGICHM7' && data.data.stUserName !== 'MAGICHM9' && data.data.stUserName !== 'MAGICHM5' && data.data.stUserName !== 'MAGICHM6') {
                    toast.success("Invalid Username or password.", {
                        theme: "green",
                        autoClose: 5000
                    })
                } else {
                    var dataToDis = data.data
                    dataToDis.token = data.token
                    dataToDis.isLogin = true
                    toast.success("Login successfull 😎", {
                        theme: "green",
                        icon: '😎',
                        autoClose: 100000
                    })
                    sessionStorage.setItem("userData", JSON.stringify(data.data));
                    localStorage.setItem("userData", JSON.stringify(data.data));
                    navigate('/')
                    setTimeout(() => {
                        navigate(0)
                    }, 200);
                }
            }
        })
    }

    const loginApi = async (username, password) => {
        const raw = JSON.stringify({
            stUserName: username, password, wkey: 'qhfueiadhfijfqeuhifgushifugqwrqwufhiahfuiashfiuhq', location: 'No'
        })

        const res = await fetch('https://postg.9xxbet.com/api/v1/users/login', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: raw
        })

        const resData = await res.json()
        return resData
    }

    const loginUser = async (e) => {
        setCLoag(true)
        e.preventDefault()
        let __POSTDATA = {
            IP: ip,
            DVC: "2",
            ID: loginData.username,
            Key: loginData.password,
            WI: __WebKeyUSER,
            Ltag: ""
        }
        let __HASH = EncryptOrderFun(JSON.stringify(__POSTDATA));

        const res = await fetch(commonUriAll._LoginUrl + `?Data=${encodeURIComponent(__HASH.toString())}`, {
            method: "POST",
            body: {},
            headers: {
                "Content-Type": "application/json"
            }
        })
        const jsonData = await res.json()
        const decrypted = await DecryptOrderFunction(jsonData)
        if (decrypted.Authorize === true && decrypted.UserType === 3) {
            if (decrypted.UserName === "RDEMONEW" || decrypted.UserName === "DSATISH1" || decrypted.UserName === "DSATISH2" || decrypted.UserName === "FUNDEMO2") {
                toast.success("Login successfull 😎", {
                    theme: "green",
                    icon: '😎',
                    autoClose: 100000
                })
                if (loginData.checkBox === true && localStorage.getItem('remember') === "false") {
                    setCockie()
                } else if (loginData.checkBox === false && localStorage.getItem('remember') === "true") {
                    removeRemember()
                }
                let SHA_256_KEY = CryptoJS.SHA256(Date.now().toString());
                sessionStorage.setItem("SHA_256_KEY", SHA_256_KEY.toString().substring(0, 32));
                sessionStorage.setItem("userData", jsonData);
                localStorage.setItem("userData", jsonData);
                navigate(0)
            } else {
                toast.error('You are not authorized')
            }
        } else {
            setCLoag(false)
            toast.error(decrypted.Message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    }

    const removeRemember = () => {
        localStorage.setItem('remember', false)
        localStorage.removeItem('username')
        localStorage.removeItem('pswd')
    }

    const setCockie = () => {
        localStorage.setItem('remember', true)
        localStorage.setItem('username', loginData.username)
        localStorage.setItem('pswd', loginData.password)
    }

    return (
        <>
            <bs-modal-backdrop class="modal-backdrop fade in show"></bs-modal-backdrop>
            <modal-container role="dialog" tabindex="-1" class="modal fade show" style={{ display: "block" }} aria-modal="true">
                <div tabindex="0" class="cdk-visually-hidden cdk-focus-trap-anchor" aria-hidden="true"></div>
                <div role="document" focustrap="" class="loginpopup modal-dialog">
                    <div class="modal-content">
                        <app-login _nghost-rka-c42="">
                            <div _ngcontent-rka-c42="" class="modal-body">
                                <button onClick={() => {
                                    dispatch(closeLoginModal())
                                }} _ngcontent-rka-c42="" type="button" class="close" fdprocessedid="7vjltp">
                                    <span _ngcontent-rka-c42="" aria-hidden="true">×</span>
                                </button>
                                <form onSubmit={loginUser2} autoComplete='off' class="loginform_modal ng-untouched ng-pristine ng-invalid">
                                    <img _ngcontent-rka-c42="" class="img-fluid" src="/assets/img/fun4club/logo4.png" />
                                    <div _ngcontent-rka-c42="" class="form-group">
                                        <label _ngcontent-rka-c42="">Username</label>
                                        <input required _ngcontent-rka-c42="" type="text" id="username" onChange={onChange} name="username" value={loginData.username} formcontrolname="username" placeholder="Username" class="form-control form-control-lg ng-untouched ng-pristine ng-invalid" />
                                    </div>
                                    <div _ngcontent-rka-c42="" class="form-group">
                                        <label _ngcontent-rka-c42="">Password</label>
                                        <div _ngcontent-rka-c42="" class="position-relative">
                                            <input name='password' _ngcontent-rka-c42="" type="password" id="password-field" formcontrolname="password" placeholder="Password" class="form-control form-control-lg ng-untouched ng-pristine ng-invalid" value={loginData.password} required onChange={onChange} />
                                            <a onClick={toggleEye} _ngcontent-rka-c42="" href="javascript:void(0)" class="eyeonoff">
                                                <i id='eye-toogle' _ngcontent-rka-c42="" class="fa fa-eye toggle-password"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div _ngcontent-rka-c42="" class="my-0 d-flex justify-content-between align-items-center">
                                        <div _ngcontent-rka-c42="" class="form-check m-0">
                                            <label _ngcontent-rka-c42="" class="form-check-label">
                                                <input onChange={onCheck} _ngcontent-rka-c42="" name='checkBox' type="checkbox" id="rememberMe" value={loginData.checkBox} defaultChecked={loginData.checkBox === "true" ? true : false} class="form-check-input" /> Keep me signed in <i _ngcontent-rka-c42="" class="input-helper"></i>
                                            </label>
                                        </div>
                                    </div>
                                    <button disabled={cLoag === true ? "disabled" : ""} class="btn btn-block btn-login w-100" fdprocessedid="jpxxq">
                                        <i _ngcontent-rka-c42="" class="fa-solid fa-arrow-right-to-bracket"></i> Sign In </button>
                                    <div _ngcontent-aou-c42="" class="d-block text-light text-center mt-2">
                                        <a _ngcontent-aou-c42="" target="_blank" href="https://www.onupdate.in/app/fun4club/fun4club.apk">
                                            <i class="fa fa-android" aria-hidden="true"></i>
                                            Download Apk </a>
                                    </div>
                                </form>
                            </div>
                        </app-login>
                    </div>
                </div>
                <div tabindex="0" class="cdk-visually-hidden cdk-focus-trap-anchor" aria-hidden="true"></div>
            </modal-container>
        </>
    )
}
